// extracted by css-extract-rspack-plugin
export default {"tags":"tags--kFOycXZLAnkbjGd7","skills":"skills--_JUwOdztacVXDToA","footer":"footer--FYZELFA0IJslJC0C"};